import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

type StyleProps = {
  isActive: boolean;
};

const styles = {
  root: ({ theme, props: { isActive } }) => css`
    display: flex;
    flex-direction: column;
    padding: 10px 12px;
    border-radius: 8px;
    overflow: hidden;
    background-color: ${theme.colors.neutral.variant[0]};
    cursor: pointer;

    &:hover {
      background-color: ${theme.colors.neutral.variant[10]};
    }

    &:active {
      background-color: ${theme.colors.neutral.variant[20]};
    }

    ${isActive &&
    css`
      &,
      &:hover,
      &:active {
        background-color: ${theme.colors.neutral.variant[20]};
      }
    `}
  `,
  noBreak: css`
    white-space: nowrap;
  `,
  noMargin: css`
    > div {
      margin: 0;
    }
  `,
  title: css`
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  `,
  subtitle: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: uppercase;
    gap: 8px;
    width: 100%;
    min-width: 0;

    > :first-child {
      max-width: 85%;
    }

    > :last-child {
      flex-shrink: 0;
    }
  `,
  icon: ({ theme }) => css`
    color: ${theme.colors.neutral.gray[70]};
    height: 15px;
  `,
  flexAlign: css`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 6px;
  `,
  dots: css`
    cursor: pointer;
    border-radius: 8px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: white;
    }
  `,
} satisfies Styles<StyleProps>;

export const useStyles = withStyles(styles);
